<template>
  <div class="city-search">
    <h3>
      Выбор региона доставки
    </h3>

    <ui-input
      v-model="query"
      name="query"
      autocomplete="off"
      placeholder="Введите название города"
      @input="query.length > 1 ? sendQuery(query) : null"
      clearable
    />

    <div
      v-if="suggests.length && query.length > 1"
      class="suggests"
    >
      <div
        v-for="city in suggests"
        :key="city.id"
        @click="chooseCity(city)"
      >
        {{ city.name }}
        <span>{{ city.region.name }} {{ city.region.kind }}</span>
      </div>
    </div>

    <div
      v-else
      class="popular"
    >
      <span>Популярные города</span>
      <div
        v-if="popularCities.length"
        class="lists"
      >
        <div
          class="lists__item"
          v-for="city in popularCities"
          :key="city.id"
          @click="chooseCity(city)"
        >
          {{ city.name }}
        </div>
      </div>
      <div
        v-else
        class="popular-loader"
      >
        <ui-loader size="60" />
      </div>
    </div>

    <div
      v-if="isLoading && !this.$city.isConfirmationNeeded"
      class="main-loader"
    >
      <ui-loader size="60" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { debounce } from 'throttle-debounce';

export default {
  name: 'city-search',

  props: {
    locally: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      query: '',
      suggests: [],
      popularCities: [],
      microCities: [],
      isConfirmationRequired: false,
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      currentCityId: 'user/cityId'
    }),
  },

  created() {
    if (!this.$isServer) {
      this.loadPopularCities();
      this.$city.loadMicroCities({ cityId: this.currentCityId });
    }
  },

  methods: {
    chooseCity(city) {
      const noWaysToGet = !city.receivingMethods.length;
      const onlyThirdparty = city.receivingMethods.length === 1 && city.receivingMethods.includes('thirdparty');

      if (noWaysToGet || onlyThirdparty) {
        this.$store.dispatch('notifications/create', {
          type: 'warning',
          title: 'Доставка недоступна',
          message: 'Для поиска товаров и оформления заказа выберите другой регион доставки',
        });
      }

      this.isLoading = true;
      this.$emit('choose', city);
    },

    loadPopularCities() {
      this.$store.$api.loadPopularCities()
        .then(cities => {
          this.popularCities = cities;
        });
    },

    sendQuery: debounce(300, false, function(query) {
      this.$store.$api.findCity({ query }).then((result) => {
        this.suggests = result;
      }).catch(() => {
        console.warn(`По запросу "${this.query}" ничего не найдено`);
      })
    })
  }
};
</script>

<style lang="scss">
.city-search {
  width: 528px;
  height: 492px;

  h3 {
    margin: 0;
    font-family: Gilroy, sans-serif;
    font-size: 16px;
    line-height: 24px;
  }

  & > .ui-input {
    margin: 16px 16px 0;
    min-height: initial;
  }

  .suggests {
    margin: 25px 16px 0;

    & > div {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      line-height: 20px;
      cursor: pointer;

      &:first-child {
        margin-top: 0;
      }
    }

    span {
      color: $gray;
      font-size: 12px;
      line-height: 20px;
    }
  }

  .popular {
    margin-top: 24px;

    & > span {
      margin: 0 16px;
      color: $gray;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .lists {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: 4px;
    max-height: 364px;
    overflow: hidden;

    & > div {
      width: 100%;
      padding: 12px 16px;
      font-size: 14px;
      line-height: 24px;
      font-weight: bold;
      border-bottom: 1px solid $gray_lu;
      cursor: pointer;

      &:nth-child(-n + 2) {
        font-weight: 600;
      }
    }
  }

  .popular-loader,
  .main-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $blue;
  }

  .popular-loader {
    height: 284px;
  }

  .main-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-30px, -30px);
  }
}

@include breakpoint("desktop") {
  .city-search {
    & > .ui-input {
      margin: 16px 0 0;
    }

    .suggests {
      margin: 25px 0 0;
    }

    .popular {
      & > span {
        margin: 0;
      }
    }

    .lists {
      & > div {
        width: 160px;
        padding: 0;
        margin-top: 8px;
        margin-right: 24px;
        line-height: 20px;
        font-weight: normal;
        border-bottom: none;
        cursor: pointer;

        &:nth-child(-n + 2) {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
